import { Avatar, Box, styled } from "@mui/material";
import { Link } from "react-router-dom";
import Admin from "src/asserts/images/png/TemasekVendor.png";
import TcsCorporate from "src/asserts/images/svg/LOGO.svg";
import TcsVendor from "src/asserts/images/svg/LOGO.svg";
import { useSelector } from "react-redux";

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

function Logo() {
  const { users } = useSelector((state: any) => state.user);

  return (
    <>
      <LogoWrapper to="/">
        {users?.detail?.role === "GA" && (
          <Box
            component="img"
            sx={{
              width: "40%",
              mr: 1,
              ml: 2.5,
            }}
            alt="Auth0"
            src={Admin}
          />
        )}
        {/* Corporate roles all get the Talent Tender mark. cpt_approver was missing here, which
            is why that role saw an empty header bar with no logo. */}
        {["system_admin", "t_user", "t_approver", "cpt_approver"].includes(
          users?.detail?.role
        ) && (
          <Box sx={{ display: "flex" }}>
            <img
              style={{
                width: "100%",
                height: "40px",
                objectFit: "contain",
                marginRight: "9px",
                marginLeft: "22.5px",
              }}
              alt="Auth0"
              src={TcsCorporate}
            />
          </Box>
        )}
        {(users?.detail?.role === "vendor_user" ||
          users?.detail?.role === "vendor_admin") && (
          <Box sx={{ display: "flex" }}>
            <img
              style={{
                width: "100%",
                height: "40px",
                objectFit: "contain",
                marginRight: "9px",
                marginLeft: "22.5px",
              }}
              alt="Auth0"
              src={TcsCorporate}
            />
          </Box>
        )}
      </LogoWrapper>
    </>
  );
}

export default Logo;
